import { useCallback, useRef, useState } from 'react';
import useCurrentVault from '@app/Areas/Optimus/State/DataStores/VaultStore/hooks/useCurrentVault';

function useCreateVaultGrandChildEntity<
    ParentModel extends { id?: number },
    CreationRequest,
    ApiModel
>(
    parent: ParentModel | null,
    create: (c: number, p: number, cr: CreationRequest) => Promise<ApiModel>,
    creationRequest: CreationRequest,
    onSuccess: (result: ApiModel) => void,
    onFinally: (vaultId: number, parentId: number) => void,
) {
    const isMounted = useRef(true);
    const currentVault = useCurrentVault();
    const [isSending, setIsSending] = useState(false);

    const sendRequest = useCallback(async () => {
        if (currentVault?.id && parent?.id && creationRequest) {
            // don't send again while we are sending
            if (isSending) return
            // update state
            setIsSending(true)
            // send the actual request
            var result = await create(currentVault.id, parent.id, creationRequest);
            if (result) {
                onSuccess(result);
            }
            onFinally(currentVault.id, parent.id);

            // once the request is sent, update state again
            if (isMounted.current) { // only update if we are still mounted
                setIsSending(false)
            }
        }
      }, [ currentVault, creationRequest, isSending, ]
    ); // update the callback if the state changes

    return {
        isSending,
        sendRequest,
    }
}

export default useCreateVaultGrandChildEntity;
